export default __webpack_public_path__ + "static/media/verify_email_illustration.748e2bb5.svg";